<div class="operation-result-container">
  <div class="operation-result-content">
    <div class="operation-result-image">
      <img
        [src]="image"
        alt="operation-result"
      />
    </div>
    <div class="operation-result-title">
      {{ titleText }}
    </div>
    <div class="operation-result-desc">
      {{ description }}
    </div>
    @if (status === 'Succeed' && !ipoDate) {
      <div class="operation-result-receipt">
        <span class="receipt-title">کد رهگیری</span>
        <span class="receipt-value">{{ receiptNumber }}</span>
      </div>
    }
  </div>

  @if (ipoDate) {
    <div class="w-100 two-columns">
      @for (button of buttons; track $index) {
        <ngx-button
          [style]="button.style"
          (clickHandler)="actionHandler(button.id)"
          [fullWidth]="true"
          [size]="button.size || 'medium'"
          [buttonId]="button.id"
        >
          {{ button.title }}
        </ngx-button>
      }
    </div>
  } @else {
    <div
      class="w-100"
      [ngClass]="{ 'operation-result-button': symbol?.startsWith('IR') && action === 'sell' && status === 'Succeed' }"
    >
      <ngx-button
        [style]="'fill'"
        (clickHandler)="onBackClicked()"
        [fullWidth]="true"
        [destructive]="false"
        size="medium"
      >
        متوجه شدم
      </ngx-button>
      @if (symbol?.startsWith('IR') && action === 'sell' && status === 'Succeed') {
        <ngx-button
          [style]="'fill'"
          (clickHandler)="goToPortfo()"
          [fullWidth]="true"
          [destructive]="false"
          size="medium"
        >
          مشاهده کیف پول
        </ngx-button>
      }
    </div>
  }
</div>
